import { call, take, put  }  from 'redux-saga/effects';
import axios                 from 'axios';
import { 
        SET_USER_LESSONS,         
        SET_USER_LESSONS_LOADER,
        RECORD_ERROR_SAGA
      }                      from '../actions';
import mockData              from '../content/mockContent/userLessons';
import { SET_ALL_CONTENT } from 'actions/contentActions';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getUserLessons.php'

const addOrigin = (arr: { [key: string]: any }) => {
   for ( let i = 0; i < arr.length; i++ ) {
       arr[i].origin = 'teacherContent';
   }

   return arr;
}


function* getUserLessons(): Generator<any,any,any> {
  while(true) {
    try {
     

        const userInput = yield take('GET_USER_LESSONS_SAGA');
       
        yield put(SET_USER_LESSONS_LOADER())

        let userName = userInput.payload;

        if ( !userName.includes('@') ) {
          userName = userName.concat('@gmail.com')
        }

        if (process.env.NODE_ENV === 'development') {
          const payload = yield addOrigin(mockData);
          yield put(SET_USER_LESSONS( payload ))
          yield put(SET_ALL_CONTENT( payload ))
        }


        if (process.env.NODE_ENV === 'production') {

            const lessons = yield call( axios.post, endpoint, { userName: userName });

            if ( !!lessons && !!lessons.data && !!lessons.data.result && !!lessons.data.result.length ) {
                const payload = yield addOrigin(lessons.data.result);
                yield put(SET_USER_LESSONS( payload ))
                yield put(SET_ALL_CONTENT( payload ))
            }

            else {
              yield put(SET_USER_LESSONS([]))
              console.log("can't get lessons")
            }

            
        }
    }
    catch(err) {
      yield put(RECORD_ERROR_SAGA({ data: { error: err }, endpoint: 'GET_USER_LESSONS_SAGA' }))
      yield put(SET_USER_LESSONS([]))
      console.log('err in getUserLessons  :  '+err);
    }
    finally {}
  }
}


export default getUserLessons;






